import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox as BsCheckbox } from 'bs-unified-ui'

const Checkbox = ({ field, meta, form, disabled, ...props }) => (
  <BsCheckbox
    checked={!!field.value}
    error={meta.touched && !!meta.error}
    disabled={disabled || !!form.values.__readOnly}
    {...field}
    {...props}
  />
)

Checkbox.defaultProps = {
  meta: {},
  disabled: false,
}

Checkbox.propTypes = {
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  meta: PropTypes.shape(),
  disabled: PropTypes.bool,
}

export default Checkbox
